module.exports = __webpack_public_path__ + "static/media/fightscout-logo.65dce8f6.svg";